import mime from 'mime';

export const reserveZipFileName = (item, usedNames) => {
  const parts = (item.doc_name || 'Unavailable file').split('.');
  if (parts.length === 1 && item.content_type) {
    const extension = mime.getExtension(item.content_type);
    if (extension) parts.push(extension);
  }

  const baseName = parts[0];
  let name = parts.join('.');
  let suffix = 1;
  while (usedNames.has(name)) {
    parts[0] = `${baseName}(${suffix})`;
    suffix += 1;
    name = parts.join('.');
  }
  // Reserve before asynchronous downloads so completion order cannot overwrite entries.
  usedNames.add(name);
  return name;
};
